import { IconReload } from '@tabler/icons-react';
import { MessageEmitter } from '@phaser/events';
import { useTranslation } from 'react-i18next';
import { sendMessage } from '@api/websocket';
import { useEffect, useState } from 'react';
import * as Shared from '@shared/lib';

export function ReloadButton() {
  const [ammo, setAmmo] = useState(-1);
  const [maxAmmo, setMaxAmmo] = useState(0);

  const { t } = useTranslation(undefined, { keyPrefix: 'Abilities' });

  const onAmmoUpdate = (ammo: number, maxAmmo: number) => {
    setAmmo(ammo);
    setMaxAmmo(maxAmmo);
  };

  useEffect(() => {
    MessageEmitter.on('ammoUpdate', onAmmoUpdate);
    return () => {
      MessageEmitter.on('ammoUpdate', onAmmoUpdate);
    };
  }, []);

  const reload = () => {
    if (ammo === maxAmmo || !ammo) return;

    sendMessage(new Shared.TriggerReloadMessage());
    MessageEmitter.emit('reload', true);
  };

  const canReload = ammo < maxAmmo && ammo > 0;
  const textClass = canReload ? 'active' : 'text-gray-700';

  return (
    <button className="flex-1 mx-auto select-none" onClick={reload}>
      <div className={`${textClass} text-2xl`}>
        <IconReload className="mx-auto" size={26} />
      </div>

      <p className="text-center text-xs text-gray-500 mt-0.75">
        {t('reload')}
      </p>
    </button>
  );
}